import { DocumentsColumnDefinition } from 'hq/components/views/documents/documents-page/table/documents-table.types';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { RawDocumentData } from 'hq/services/documents-service.types';

export const getDocumentTableData = (data: RawDocumentData[]) => {
  const result: DocumentsColumnDefinition[] = data.flatMap((item) => ({
    id: item.id,
    documentNameCopy: item.documentNameCopy,
    documentTypeCopy: item.documentTypeCopy,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
    status: item.status,
    flexWorkerName: {
      name: getFullNameWithInfix({
        firstName: item.firstName,
        infix: item.infix,
        lastName: item.lastName,
      }),
      hasNotification: item.notification,
    },
    issuer: item.issuer,
    actions: { documentId: item.id },
  }));

  return result;
};
